import React, { useEffect } from "react";
import AllFishSeaFoods from "../Fish&SeaFoods/AllFish&SeaFoods";
import Header from "../Home/Header";
import Footer from "../Footer/Footer";
const FishSeaFoods = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);
  return (
    <>
      <Header />
      <AllFishSeaFoods/>
      <Footer />
    </>
  );
};

export default FishSeaFoods;
